<template>
  <generic-modal :modal-key="'bundle_discount'" :has-extra-modal-class="'bonus_phase_box daily_bonus modal_cont'"
                 @close="closeModal">
    <template slot="content">
        <h1>{{ getTranslations.home_bundle_discount_header}}</h1>
        <img src="static/images/daily_bonus/photo-DiscountBonus.png" class="bonus_img">
        <div class="double_points_bg" v-if="counter">
          <h2>{{ getTranslations.home_bundle_amount_of_games }}</h2>
          <h3>{{ getTranslations.home_bundle_discount_duration }}</h3>
          <div class="store_countdown" id="disc_counter">
            <p v-if="counter"></p>
          </div>
        </div>
        <h4>{{ getTranslations.home_bundle_discount_between_part_1 }}
          {{ dateStart }} - {{ dateEnd }}
          {{ getTranslations.home_bundle_discount_between_part_2 }}{{ phaseBonusModalToBeDisplayed.multiplier }}</h4>
        <h5>{{ getTranslations.home_bundle_discount_purchase_bundles }}</h5>
        <button type="button" @click.prevent="goToStorePage">{{ getTranslations.home_bundle_discount_store }}</button>
    </template>
  </generic-modal>
</template>

<script>
// discount_bonus_pop_up.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';
import GenericModal from '../../sharedcomponents/GenericModal';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bundle-discount',
  components: { GenericModal },
  data() {
    return {
      timer: 0,
      counter: '',
      dateStart: null,
      dateEnd: null,
    };
  },
  beforeDestroy() {
    this.closeModal();
    this.updatePhaseBonusModalToBeDisplayed(null);
  },
  created() {
    moment.locale('EN');
    this.dateStart = moment(this.phaseBonusModalToBeDisplayed.start).format('hh:mm:ss');
    this.dateEnd = moment(this.phaseBonusModalToBeDisplayed.end).format('hh:mm:ss');
    const interval = 1000; // every 1 second
    let duration;
    // get time element
    // calculate difference between two times
    const eventTime = moment(this.phaseBonusModalToBeDisplayed.end);
    // loop to countdown every 1 second
    this.timer = setInterval(() => {
      // based on time set in user's computer time / OS
      const currentTime = moment(new Date());
      // get duration between two times
      duration = moment.duration(eventTime.diff(currentTime));
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');

      // if duration is >= 0
      if (currentTime.isAfter(eventTime)) {
        clearInterval(this.timer);
        // hide the countdown element
        this.counter = '';
        this.phaseBonusModalToBeDisplayed.active = false;
      } else {
        // otherwise, show the updated countdown
        this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        $('#disc_counter').html(this.counter);
      }
    }, interval);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'updatePhaseBonusModalToBeDisplayed',
      'saveBonusDailyModal',
    ]),
    closeModal() {
      this.storeModalForHomePage(null);
      this.saveBonusDailyModal(null);
    },
    goToStorePage() {
      this.closeModal();
      this.$router.push('/home/store');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'phaseBonusModalToBeDisplayed',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/BundleDiscount.vue